
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.833 7h-7V5.833A5.835 5.835 0 0118.667 0h1.166a3.51 3.51 0 013.5 3.5 3.51 3.51 0 01-3.5 3.5zm-4.468-2.333h4.468A1.17 1.17 0 0021 3.5a1.17 1.17 0 00-1.167-1.167h-1.166c-1.517 0-2.824.98-3.302 2.334z"}}),_c('path',{attrs:{"d":"M15.167 7h-7a3.51 3.51 0 01-3.5-3.5 3.51 3.51 0 013.5-3.5h1.166a5.835 5.835 0 015.834 5.833V7zm-7-4.667A1.17 1.17 0 007 3.5a1.17 1.17 0 001.167 1.167h4.468a3.516 3.516 0 00-3.302-2.334H8.167zM2.333 14v12.833A1.17 1.17 0 003.5 28h9.333V14h-10.5z"}}),_c('path',{attrs:{"d":"M1.167 11.667h11.666v-7H1.167A1.17 1.17 0 000 5.833V10.5a1.17 1.17 0 001.167 1.167zM15.167 14v14H24.5a1.17 1.17 0 001.167-1.167V14h-10.5zM26.833 4.667H15.167v7h11.666A1.17 1.17 0 0028 10.5V5.833a1.17 1.17 0 00-1.167-1.166z"}})])
          )
        }
      }
    